import { useQuery } from "@tanstack/react-query";
import fetchApi from "../fetchApi";
import { ErrorResponse } from "../../models/apiResponse";
import { Customer } from "../../models/Service";

const useQueryCustomer = ({
  customerCode,
  corporateId,
  enabled = false,
  authorisation = "",
}: {
  customerCode: string;
  corporateId: string;
  enabled?: boolean;
  authorisation?: string;
}) => {
  return useQuery(
    [`/corporate-subsidiary/${corporateId}/customer/${customerCode}`],
    () =>
      fetchApi(`corporate-subsidiary/${corporateId}/customer/${customerCode}`, {
        headers: {
          Authorization: `Bearer ${authorisation}`,
        },
      }).get<Customer | ErrorResponse>(),
    {
      staleTime: 1000 * 60 * 1,
      refetchOnWindowFocus: false,
      enabled,
    }
  );
};

export default useQueryCustomer;
